const {Urls} = require(BUILD_ENV == "prod" ? "./prodConstants": BUILD_ENV == "dr" ? "./drConstants" : "./demoConstants")

export {
  Urls
}
